module.exports = __webpack_public_path__ + "img/elecciones20214.106eb60e.jpg";